class AppConstructorModel {
  constructor({
    id = null,
    channel = null,
    environment = null,
    endpoints = null,
    headers = null,
  } = {}) {
    this.id = id;
    this.channel = channel;
    this.environment = environment;
    this.endpoints = endpoints;
    this.headers = headers;
  }
  json() {
    return {
      id: this.id,
      channel: this.channel,
      environment: this.environment,
      endpoints: this.endpoints,
      headers: this.headers,
    };
  }
}

module.exports = AppConstructorModel;
